import { executeUI } from '@common/utils/ui-bridge';
import { loadIndividualSpreadsheetFormat, loadPedigreeSpreadsheetFormat } from '@common/actions/table';
import client from '@common/utils/rest';
import { SPREADSHEET_TYPE } from '../const/common';
import { clearFormatData } from '@modules/spreadsheets/actions/spreadsheetFormat';

const URL_PREFIX = 'api/spreadSheets';
const FORMATS_URL_PREFIX = `${URL_PREFIX}/formats`;
const MODULE_NAME = 'SPREADSHEETS'

export const getFormats = (spreadsheetType, { folderId, searchKeyword }) => {
	const spreadsheetTypePath = {
		[SPREADSHEET_TYPE.individual]: 'individuals',
		[SPREADSHEET_TYPE.pedigree]: 'pedigrees',
	};
	const pathConfig = [
		{
			condition: Boolean(searchKeyword),
			path: `${FORMATS_URL_PREFIX}/search/${spreadsheetTypePath[spreadsheetType]}?query=${searchKeyword}`
		},
		{
			condition: !searchKeyword,
			path: `${FORMATS_URL_PREFIX}/${folderId}?context=${spreadsheetType}`
		}
	];

	const currentRequestConfig = pathConfig.find(({ condition }) => condition);

	return client({
		path: currentRequestConfig.path,
		method: 'GET',
	}).then(
		(response) => {
			return response.entity.formats;
		},
	);
};

export const getFormatsColumnsWidth = (spreadsheetType) => {
	return client({
		path: `${URL_PREFIX}/columns/width?context=${spreadsheetType}`,
		method: 'GET'
	}).then((response) => {
		return response.entity.columnWidths;
	});
};

export const setFormatColumnsWidth = (spreadsheetType, { columnName, columnWidth }) => {
	return client({
		path: `${URL_PREFIX}/columns/width?context=${spreadsheetType}&width=${columnWidth}&columnName=${columnName}`,
		method: 'POST',
	});
};

export const deleteFormat = (spreadsheetType, formatId) => {
	return client({
		path: `${FORMATS_URL_PREFIX}/?context=${spreadsheetType}&reportNumber=${formatId}`,
		method: 'POST'
	});
};

export const openNewSpreadsheet = (spreadsheetType) => {
	const action = {
		[SPREADSHEET_TYPE.individual]: 'openISS',
		[SPREADSHEET_TYPE.pedigree]: 'openPSS'
	};

	executeUI(MODULE_NAME, action[spreadsheetType]);
};

export const editSpreadsheet = async (spreadsheetType, id, name) => {
    const action = {
        [SPREADSHEET_TYPE.individual]: 'openISS',
        [SPREADSHEET_TYPE.pedigree]: 'openPSS'
    };


    executeUI(MODULE_NAME, action[spreadsheetType], id, name, null);
};

export const openExistedSpreadsheet = (spreadsheetType, id, name) => {
	const action = {
		[SPREADSHEET_TYPE.individual]: 'runISS',
		[SPREADSHEET_TYPE.pedigree]: 'runPSS'
	};

	// Clear existing Redux data to force fresh fetch from API
	if (typeof window !== 'undefined' && (window).__SPREADSHEET_STORE__) {
		const store = (window).__SPREADSHEET_STORE__;
		const spreadsheetTypeKey = spreadsheetType === SPREADSHEET_TYPE.individual ? 'Individual' : 'Pedigree';
		store.dispatch(clearFormatData(Number(id), spreadsheetTypeKey));
	}

	executeUI(MODULE_NAME, action[spreadsheetType], id, name, null);
};

export const canDeleteSpreadsheet = () => {
	return client({
		path: `${URL_PREFIX}/deleteFormatAllowed`,
		method: 'GET',
	}).then((x) => x.entity);
};